/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type FC } from 'react';

import {
  BotCard,
  type BotCardProps,
} from '@coze-studio/workspace-base/develop';
import { IntelligenceType } from '@coze-arch/idl/intelligence_api';

import { OntologyUsageChips } from '../ontology-usage-chips';
import { useOntologyUsageForItem } from '../../hooks/use-ontology-usage';

import styles from './index.module.less';

export type BotCardTechProps = BotCardProps;

export const BotCardTech: FC<BotCardTechProps> = props => {
  const ontologyNames = useOntologyUsageForItem(props.intelligenceInfo);
  const isPublished = props.intelligenceInfo.publish_info?.has_published;
  const isAgent = props.intelligenceInfo.type === IntelligenceType.Bot;

  return (
    <div className={styles.techCard}>
      <div className={styles.techCardBar} />
      <div className={styles.techCardBody}>
        <div className={styles.techCardHead}>
          <div className={styles.techCardMeta}>
            <span className={styles.techType}>
              {isAgent ? 'AGENT' : 'WORKFLOW'}
            </span>
            <span
              className={isPublished ? styles.statusLive : styles.statusDraft}
            >
              {isPublished ? 'LIVE' : 'DRAFT'}
            </span>
          </div>
        </div>
        <div className={styles.botCardWrap}>
          <BotCard {...props} />
        </div>
        <OntologyUsageChips names={ontologyNames} />
      </div>
    </div>
  );
};
